import { render, staticRenderFns } from "./RegionNestedTable.vue?vue&type=template&id=37141088&scoped=true"
import script from "./RegionNestedTable.vue?vue&type=script&lang=js"
export * from "./RegionNestedTable.vue?vue&type=script&lang=js"
import style0 from "./RegionNestedTable.vue?vue&type=style&index=0&id=37141088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37141088",
  null
  
)

export default component.exports